import { TeamMemberProgress, UserProgress } from "../models/TeamMember";
import { VirtualTeam } from "../models/Team";
import { RISUser } from "../models/RISUser";
import { TeamsSearchResult } from "../models/TeamsSearchResult";
import { Acknowledgment } from "../models/Acknowledgement";
import { OrgUser } from "../../pages/user-administration/OrgUser";

export const GET_TEAM_MEMBERS = "GET_TEAM_MEMBERS";
export const GET_PROGRESS_OF_TEAM = "GET_PROGRESS_OF_TEAM";
export const GET_USERS = "GET_USERS";
export const GET_ORG_TEAMS = "GET_ORG_TEAMS";
export const SEARCH_ORG_TEAMS = "SEARCH_ORG_TEAMS";
export const GET_MY_TEAMS = "GET_MY_TEAMS";
export const GET_MY_PROGRESS = "GET_MY_PROGRESS";
export const GET_PROGRESS_OF_USERS = "GET_PROGRESS_OF_USERS";
export const GET_MY_UNRESPONDED_MESSAGE_COUNT = "GET_MY_UNRESPONDED_MESSAGE_COUNT";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const UPDATE_USER_OPT_IN_ROLES = "UPDATE_USER_OPT_IN_ROLES";
export const UPDATE_USER_LOCATIONS = "UPDATE_USER_LOCATIONS";

export interface GetTeamMembers {
  type: typeof GET_TEAM_MEMBERS;
  payload: TeamMemberProgress[] | undefined;
}

export interface GetUsers {
  type: typeof GET_USERS;
  payload: RISUser[] | undefined;
}

export interface GetOrgTeams {
  type: typeof GET_ORG_TEAMS;
  payload: VirtualTeam[] | undefined;
}

export interface SearchOrgTeams {
  type: typeof SEARCH_ORG_TEAMS;
  payload: TeamsSearchResult;
}

export interface GetMyTeams {
  type: typeof GET_MY_TEAMS;
  payload: VirtualTeam[] | undefined;
}

export interface GetProgressOfTeam {
  type: typeof GET_PROGRESS_OF_TEAM;
  payload: TeamMemberProgress[];
}

export interface GetMyProgress {
  type: typeof GET_MY_PROGRESS;
  payload: UserProgress;
}

export interface GetProgressOfUsers {
  type: typeof GET_PROGRESS_OF_USERS;
  payload: Acknowledgment[];
}

export interface GetMyUnrespondedMessageCount {
  type: typeof GET_MY_UNRESPONDED_MESSAGE_COUNT;
  payload: number;
}

export interface GetAllUsers {
  type: typeof GET_ALL_USERS;
  payload: OrgUser[];
}

export interface UpdateUserOptInRoles {
  type: typeof UPDATE_USER_OPT_IN_ROLES;
  payload: { userId: string; optInRoleIds: string[] };
}

export interface UpdateUserLocations {
  type: typeof UPDATE_USER_LOCATIONS;
  payload: { userId: string; locationIds: string[] };
}

export type TeamMembersActions =
  | GetUsers
  | GetOrgTeams
  | GetTeamMembers
  | SearchOrgTeams
  | GetMyTeams
  | GetProgressOfTeam
  | GetMyProgress
  | GetProgressOfUsers
  | GetMyUnrespondedMessageCount
  | GetAllUsers
  | UpdateUserOptInRoles
  | UpdateUserLocations;
